export const GOOGLE_MAPS_KEY: string = (import.meta.env.VITE_GOOGLE_MAPS_KEY as string | undefined) ?? ''

export const MAP_ID = 'dashboard-map'

export const DEFAULT_CAMERA = {
  zoom: 7,
  center: { lat: 52.0693, lng: 19.4803 },
}
